import { formatText } from "@ui/format";
import React from "react";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import { LeadForm as ParentLeadForm } from "../../LeadForm/Steps/LeadForm";
import type { MortgageLeadFormStepProps } from "../../LeadForm/Steps/LeadForm";

interface Props extends MortgageLeadFormStepProps {
	loanAmount: number;
	maturityYears: number;
	installment: number;
	apr: number;
}

export class PartnerLeadForm extends ParentLeadForm<Props> {
	protected renderHeader(): ReactNode {
		const { loanAmount, maturityYears, installment, apr } = this.props;

		return (
			<Card.Header className="font-weight-bold h5">
				<Card.Title className="text-white text-center">
					<span className="d-inline-block bg-white text-success mb-2 px-1">
						{formatText(Math.floor(loanAmount / 1_000_000), "millió ft")}
					</span>{" "}
					hitel,{" "}
					<span className="d-inline-block bg-white text-success mb-2 px-1">
						{formatText(maturityYears, "év")}
					</span>{" "}
					futamidőre
					<br /> havi{" "}
					<span className="d-inline-block bg-white text-success mb-2 px-1">
						{formatText(installment, "ft")}
					</span>{" "}
					-tól, <span className="d-inline-block bg-white text-success mb-2 px-1">{formatText(apr, "%")}</span>{" "}
					THM-től.
				</Card.Title>
			</Card.Header>
		);
	}
}
